import { takeLatest, put, call, select, take } from 'redux-saga/effects';
import { push } from 'connected-react-router';

import {
  getSchemasIfNeeded,
  getPaginatedSchemasIfNeeded,
  getSchemaKeys,
  getSchemaIfNeeded,
  createSchemaFromCurrent,
  activateOrDeactivateSchema,
  updateSchemaFromCurrent,
  getEventTypesIfNeeded,
  getEventIdentifierValuesIfNeeded,
  getSchemaOptionsIfNeeded
} from './sagas';

import {
  CREATE_SCHEMA,
  GET_SCHEMAS,
  GET_PAGINATED_SCHEMAS,
  GET_SCHEMA_KEYS,
  GET_SCHEMA,
  ACTIVATE_OR_DEACTIVATE_SCHEMA,
  CREATING_SCHEMA_SUCCEEDED,
  UPDATE_SCHEMA,
  UPDATING_SCHEMA_SUCCEEDED,
  GET_EVENT_TYPES,
  GET_EVENT_IDENTIFIER_VALUES,
  GET_SCHEMA_OPTIONS,
  getSchema
} from './actions';

import { actions as UserActions } from '../user';

function* forceGetSchema(action) {
  const schemaId = action.payload.id;
  if (schemaId) {
    yield put(getSchema({ force: true, schemaId: schemaId }));
    yield put(push(`/schema/design/${schemaId}`));
  }
}

function* waitForUserReady() {
  const userReady = yield select((store) => store.user.ready);
  if (!userReady) {
    yield take(UserActions.LOGIN_READY);
  }
}

function* SchemaGetManySaga() {
  yield takeLatest(GET_SCHEMAS, function* (action) {
    yield call(waitForUserReady);
    yield call(getSchemasIfNeeded, action);
  });
}

function* PaginatedSchemaGetManySaga() {
  yield takeLatest(GET_PAGINATED_SCHEMAS, function* (action) {
    yield call(waitForUserReady);
    yield call(getPaginatedSchemasIfNeeded, action);
  });
}

function* SchemaGetSingleSaga() {
  yield takeLatest(GET_SCHEMA, function* (action) {
    yield call(waitForUserReady);
    yield call(getSchemaIfNeeded, action);
  });
}

function* SchemaGetKeysSaga() {
  yield takeLatest(GET_SCHEMA_KEYS, function* () {
    yield call(waitForUserReady);
    yield call(getSchemaKeys);
  });
}

function* SchemaGetEventTypesSaga() {
  yield takeLatest(GET_EVENT_TYPES, function* (action) {
    yield call(waitForUserReady);
    yield call(getEventTypesIfNeeded, action);
  });
}

function* SchemaActivateOrDeactivateSaga() {
  yield takeLatest(ACTIVATE_OR_DEACTIVATE_SCHEMA, function* (action) {
    yield call(activateOrDeactivateSchema, action);
  });
}

function* SchemaCreateSaga() {
  yield takeLatest(CREATE_SCHEMA, createSchemaFromCurrent);
}

function* SchemaUpdateSaga() {
  yield takeLatest(UPDATE_SCHEMA, function* (action) {
    yield call(updateSchemaFromCurrent, action);
  });
}

function* SchemaCreateSuccessSaga() {
  yield takeLatest(CREATING_SCHEMA_SUCCEEDED, forceGetSchema);
}

function* SchemaUpdateSuccessSaga() {
  yield takeLatest(UPDATING_SCHEMA_SUCCEEDED, forceGetSchema);
}

function* SchemaGetEventIdentifierValuesSaga() {
  yield takeLatest(GET_EVENT_IDENTIFIER_VALUES, function* (action) {
    yield call(getEventIdentifierValuesIfNeeded, action);
  });
}

function* SchemaGetOptionsSaga() {
  yield takeLatest(GET_SCHEMA_OPTIONS, function* (action) {
    yield call(waitForUserReady);
    yield call(getSchemaOptionsIfNeeded, action);
  });
}

export default [
  SchemaGetManySaga,
  PaginatedSchemaGetManySaga,
  SchemaGetKeysSaga,
  SchemaGetSingleSaga,
  SchemaCreateSaga,
  SchemaActivateOrDeactivateSaga,
  SchemaUpdateSaga,
  SchemaCreateSuccessSaga,
  SchemaUpdateSuccessSaga,
  SchemaGetEventTypesSaga,
  SchemaGetEventIdentifierValuesSaga,
  SchemaGetOptionsSaga
];
